import { assignParentProductsToTenant, AssignProductsRequest } from '../../admin/catalog';

export const catalogQueries = {
  mutations: {
    assignParentProductsToTenant: (tenantId: number) => ({
      mutationKey: ['admin', 'catalog', 'assign-parent-products-to-tenant', tenantId],
      mutationFn: async (data: AssignProductsRequest) => {
        return assignParentProductsToTenant(tenantId, data);
      }
    })
  }
};
